"use strict";

var _classCallCheck = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountStateBuilder = void 0;

var AccountKeyTypeFlagsDto_1 = require("./AccountKeyTypeFlagsDto");

var AccountStateFormatDto_1 = require("./AccountStateFormatDto");

var AddressDto_1 = require("./AddressDto");

var GeneratorUtils_1 = require("./GeneratorUtils");

var HeightActivityBucketsBuilder_1 = require("./HeightActivityBucketsBuilder");

var HeightDto_1 = require("./HeightDto");

var ImportanceSnapshotBuilder_1 = require("./ImportanceSnapshotBuilder");

var MosaicBuilder_1 = require("./MosaicBuilder");

var PinnedVotingKeyBuilder_1 = require("./PinnedVotingKeyBuilder");

var PublicKeyDto_1 = require("./PublicKeyDto");

var StateHeaderBuilder_1 = require("./StateHeaderBuilder");

var AccountStateBuilder = /*#__PURE__*/function (_StateHeaderBuilder_) {
  _inherits(AccountStateBuilder, _StateHeaderBuilder_);

  var _super = _createSuper(AccountStateBuilder);

  function AccountStateBuilder(version, address, addressHeight, publicKey, publicKeyHeight, accountType, format, supplementalPublicKeysMask, linkedPublicKey, nodePublicKey, vrfPublicKey, votingPublicKeys, importanceSnapshots, activityBuckets, balances) {
    var _this;

    _classCallCheck(this, AccountStateBuilder);

    _this = _super.call(this, version);
    GeneratorUtils_1.GeneratorUtils.notNull(address, 'address is null or undefined');
    GeneratorUtils_1.GeneratorUtils.notNull(addressHeight, 'addressHeight is null or undefined');
    GeneratorUtils_1.GeneratorUtils.notNull(publicKey, 'publicKey is null or undefined');
    GeneratorUtils_1.GeneratorUtils.notNull(publicKeyHeight, 'publicKeyHeight is null or undefined');
    GeneratorUtils_1.GeneratorUtils.notNull(accountType, 'accountType is null or undefined');
    GeneratorUtils_1.GeneratorUtils.notNull(format, 'format is null or undefined');
    GeneratorUtils_1.GeneratorUtils.notNull(supplementalPublicKeysMask, 'supplementalPublicKeysMask is null or undefined');

    if (supplementalPublicKeysMask.indexOf(AccountKeyTypeFlagsDto_1.AccountKeyTypeFlagsDto.LINKED) > -1) {
      GeneratorUtils_1.GeneratorUtils.notNull(linkedPublicKey, 'linkedPublicKey is null or undefined');
    }

    if (supplementalPublicKeysMask.indexOf(AccountKeyTypeFlagsDto_1.AccountKeyTypeFlagsDto.NODE) > -1) {
      GeneratorUtils_1.GeneratorUtils.notNull(nodePublicKey, 'nodePublicKey is null or undefined');
    }

    if (supplementalPublicKeysMask.indexOf(AccountKeyTypeFlagsDto_1.AccountKeyTypeFlagsDto.VRF) > -1) {
      GeneratorUtils_1.GeneratorUtils.notNull(vrfPublicKey, 'vrfPublicKey is null or undefined');
    }

    GeneratorUtils_1.GeneratorUtils.notNull(votingPublicKeys, 'votingPublicKeys is null or undefined');

    if (format === AccountStateFormatDto_1.AccountStateFormatDto.HIGH_VALUE) {
      GeneratorUtils_1.GeneratorUtils.notNull(importanceSnapshots, 'importanceSnapshots is null or undefined');
    }

    if (format === AccountStateFormatDto_1.AccountStateFormatDto.HIGH_VALUE) {
      GeneratorUtils_1.GeneratorUtils.notNull(activityBuckets, 'activityBuckets is null or undefined');
    }

    GeneratorUtils_1.GeneratorUtils.notNull(balances, 'balances is null or undefined');
    _this.address = address;
    _this.addressHeight = addressHeight;
    _this.publicKey = publicKey;
    _this.publicKeyHeight = publicKeyHeight;
    _this.accountType = accountType;
    _this.format = format;
    _this.supplementalPublicKeysMask = supplementalPublicKeysMask;
    _this.linkedPublicKey = linkedPublicKey;
    _this.nodePublicKey = nodePublicKey;
    _this.vrfPublicKey = vrfPublicKey;
    _this.votingPublicKeys = votingPublicKeys;
    _this.importanceSnapshots = importanceSnapshots;
    _this.activityBuckets = activityBuckets;
    _this.balances = balances;
    return _this;
  }

  _createClass(AccountStateBuilder, [{
    key: "getAddress",
    value: function getAddress() {
      return this.address;
    }
  }, {
    key: "getAddressHeight",
    value: function getAddressHeight() {
      return this.addressHeight;
    }
  }, {
    key: "getPublicKey",
    value: function getPublicKey() {
      return this.publicKey;
    }
  }, {
    key: "getPublicKeyHeight",
    value: function getPublicKeyHeight() {
      return this.publicKeyHeight;
    }
  }, {
    key: "getAccountType",
    value: function getAccountType() {
      return this.accountType;
    }
  }, {
    key: "getFormat",
    value: function getFormat() {
      return this.format;
    }
  }, {
    key: "getSupplementalPublicKeysMask",
    value: function getSupplementalPublicKeysMask() {
      return this.supplementalPublicKeysMask;
    }
  }, {
    key: "getLinkedPublicKey",
    value: function getLinkedPublicKey() {
      if (!(this.supplementalPublicKeysMask.indexOf(AccountKeyTypeFlagsDto_1.AccountKeyTypeFlagsDto.LINKED) > -1 && this.linkedPublicKey)) {
        throw new Error('supplementalPublicKeysMask is not set to LINKED.');
      }

      return this.linkedPublicKey;
    }
  }, {
    key: "getNodePublicKey",
    value: function getNodePublicKey() {
      if (!(this.supplementalPublicKeysMask.indexOf(AccountKeyTypeFlagsDto_1.AccountKeyTypeFlagsDto.NODE) > -1 && this.nodePublicKey)) {
        throw new Error('supplementalPublicKeysMask is not set to NODE.');
      }

      return this.nodePublicKey;
    }
  }, {
    key: "getVrfPublicKey",
    value: function getVrfPublicKey() {
      if (!(this.supplementalPublicKeysMask.indexOf(AccountKeyTypeFlagsDto_1.AccountKeyTypeFlagsDto.VRF) > -1 && this.vrfPublicKey)) {
        throw new Error('supplementalPublicKeysMask is not set to VRF.');
      }

      return this.vrfPublicKey;
    }
  }, {
    key: "getVotingPublicKeys",
    value: function getVotingPublicKeys() {
      return this.votingPublicKeys;
    }
  }, {
    key: "getImportanceSnapshots",
    value: function getImportanceSnapshots() {
      if (!(this.format === AccountStateFormatDto_1.AccountStateFormatDto.HIGH_VALUE && this.importanceSnapshots)) {
        throw new Error('format is not set to HIGH_VALUE.');
      }

      return this.importanceSnapshots;
    }
  }, {
    key: "getActivityBuckets",
    value: function getActivityBuckets() {
      if (!(this.format === AccountStateFormatDto_1.AccountStateFormatDto.HIGH_VALUE && this.activityBuckets)) {
        throw new Error('format is not set to HIGH_VALUE.');
      }

      return this.activityBuckets;
    }
  }, {
    key: "getBalances",
    value: function getBalances() {
      return this.balances;
    }
  }, {
    key: "getSize",
    value: function getSize() {
      var size = _get(_getPrototypeOf(AccountStateBuilder.prototype), "getSize", this).call(this);

      size += this.address.getSize();
      size += this.addressHeight.getSize();
      size += this.publicKey.getSize();
      size += this.publicKeyHeight.getSize();
      size += 1;
      size += 1;
      size += 1;
      size += 1;

      if (this.supplementalPublicKeysMask.indexOf(AccountKeyTypeFlagsDto_1.AccountKeyTypeFlagsDto.LINKED) > -1) {
        size += this.linkedPublicKey.getSize();
      }

      if (this.supplementalPublicKeysMask.indexOf(AccountKeyTypeFlagsDto_1.AccountKeyTypeFlagsDto.NODE) > -1) {
        size += this.nodePublicKey.getSize();
      }

      if (this.supplementalPublicKeysMask.indexOf(AccountKeyTypeFlagsDto_1.AccountKeyTypeFlagsDto.VRF) > -1) {
        size += this.vrfPublicKey.getSize();
      }

      size += this.votingPublicKeys.reduce(function (sum, c) {
        return sum + GeneratorUtils_1.GeneratorUtils.getSizeWithPadding(c.getSize(), 0);
      }, 0);

      if (this.format === AccountStateFormatDto_1.AccountStateFormatDto.HIGH_VALUE) {
        size += this.importanceSnapshots.getSize();
      }

      if (this.format === AccountStateFormatDto_1.AccountStateFormatDto.HIGH_VALUE) {
        size += this.activityBuckets.getSize();
      }

      size += 2;
      size += this.balances.reduce(function (sum, c) {
        return sum + GeneratorUtils_1.GeneratorUtils.getSizeWithPadding(c.getSize(), 0);
      }, 0);
      return size;
    }
  }, {
    key: "serialize",
    value: function serialize() {
      var newArray = Uint8Array.from([]);

      var superBytes = _get(_getPrototypeOf(AccountStateBuilder.prototype), "serialize", this).call(this);

      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, superBytes);
      var addressBytes = this.address.serialize();
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, addressBytes);
      var addressHeightBytes = this.addressHeight.serialize();
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, addressHeightBytes);
      var publicKeyBytes = this.publicKey.serialize();
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, publicKeyBytes);
      var publicKeyHeightBytes = this.publicKeyHeight.serialize();
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, publicKeyHeightBytes);
      var accountTypeBytes = GeneratorUtils_1.GeneratorUtils.uint8ToBuffer(this.accountType);
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, accountTypeBytes);
      var formatBytes = GeneratorUtils_1.GeneratorUtils.uint8ToBuffer(this.format);
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, formatBytes);
      var supplementalPublicKeysMaskBytes = GeneratorUtils_1.GeneratorUtils.uint8ToBuffer(GeneratorUtils_1.GeneratorUtils.fromFlags(AccountKeyTypeFlagsDto_1.AccountKeyTypeFlagsDto, this.supplementalPublicKeysMask));
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, supplementalPublicKeysMaskBytes);
      var votingPublicKeysCountBytes = GeneratorUtils_1.GeneratorUtils.uint8ToBuffer(this.votingPublicKeys.length);
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, votingPublicKeysCountBytes);

      if (this.supplementalPublicKeysMask.indexOf(AccountKeyTypeFlagsDto_1.AccountKeyTypeFlagsDto.LINKED) > -1) {
        var linkedPublicKeyBytes = this.linkedPublicKey.serialize();
        newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, linkedPublicKeyBytes);
      }

      if (this.supplementalPublicKeysMask.indexOf(AccountKeyTypeFlagsDto_1.AccountKeyTypeFlagsDto.NODE) > -1) {
        var nodePublicKeyBytes = this.nodePublicKey.serialize();
        newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, nodePublicKeyBytes);
      }

      if (this.supplementalPublicKeysMask.indexOf(AccountKeyTypeFlagsDto_1.AccountKeyTypeFlagsDto.VRF) > -1) {
        var vrfPublicKeyBytes = this.vrfPublicKey.serialize();
        newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, vrfPublicKeyBytes);
      }

      var votingPublicKeysBytes = GeneratorUtils_1.GeneratorUtils.writeList(this.votingPublicKeys, 0);
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, votingPublicKeysBytes);

      if (this.format === AccountStateFormatDto_1.AccountStateFormatDto.HIGH_VALUE) {
        var importanceSnapshotsBytes = this.importanceSnapshots.serialize();
        newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, importanceSnapshotsBytes);
      }

      if (this.format === AccountStateFormatDto_1.AccountStateFormatDto.HIGH_VALUE) {
        var activityBucketsBytes = this.activityBuckets.serialize();
        newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, activityBucketsBytes);
      }

      var balancesCountBytes = GeneratorUtils_1.GeneratorUtils.uint16ToBuffer(this.balances.length);
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, balancesCountBytes);
      var balancesBytes = GeneratorUtils_1.GeneratorUtils.writeList(this.balances, 0);
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, balancesBytes);
      return newArray;
    }
  }], [{
    key: "loadFromBinary",
    value: function loadFromBinary(payload) {
      var byteArray = Array.from(payload);
      var superObject = StateHeaderBuilder_1.StateHeaderBuilder.loadFromBinary(payload);
      byteArray.splice(0, superObject.getSize());
      var address = AddressDto_1.AddressDto.loadFromBinary(Uint8Array.from(byteArray));
      byteArray.splice(0, address.getSize());
      var addressHeight = HeightDto_1.HeightDto.loadFromBinary(Uint8Array.from(byteArray));
      byteArray.splice(0, addressHeight.getSize());
      var publicKey = PublicKeyDto_1.PublicKeyDto.loadFromBinary(Uint8Array.from(byteArray));
      byteArray.splice(0, publicKey.getSize());
      var publicKeyHeight = HeightDto_1.HeightDto.loadFromBinary(Uint8Array.from(byteArray));
      byteArray.splice(0, publicKeyHeight.getSize());
      var accountType = GeneratorUtils_1.GeneratorUtils.bufferToUint8(Uint8Array.from(byteArray));
      byteArray.splice(0, 1);
      var format = GeneratorUtils_1.GeneratorUtils.bufferToUint8(Uint8Array.from(byteArray));
      byteArray.splice(0, 1);
      var supplementalPublicKeysMask = GeneratorUtils_1.GeneratorUtils.toFlags(AccountKeyTypeFlagsDto_1.AccountKeyTypeFlagsDto, GeneratorUtils_1.GeneratorUtils.bufferToUint8(Uint8Array.from(byteArray)));
      byteArray.splice(0, 1);
      var votingPublicKeysCount = GeneratorUtils_1.GeneratorUtils.bufferToUint8(Uint8Array.from(byteArray));
      byteArray.splice(0, 1);
      var linkedPublicKey = undefined;

      if (supplementalPublicKeysMask.indexOf(AccountKeyTypeFlagsDto_1.AccountKeyTypeFlagsDto.LINKED) > -1) {
        linkedPublicKey = PublicKeyDto_1.PublicKeyDto.loadFromBinary(Uint8Array.from(byteArray));
        byteArray.splice(0, linkedPublicKey.getSize());
      }

      var nodePublicKey = undefined;

      if (supplementalPublicKeysMask.indexOf(AccountKeyTypeFlagsDto_1.AccountKeyTypeFlagsDto.NODE) > -1) {
        nodePublicKey = PublicKeyDto_1.PublicKeyDto.loadFromBinary(Uint8Array.from(byteArray));
        byteArray.splice(0, nodePublicKey.getSize());
      }

      var vrfPublicKey = undefined;

      if (supplementalPublicKeysMask.indexOf(AccountKeyTypeFlagsDto_1.AccountKeyTypeFlagsDto.VRF) > -1) {
        vrfPublicKey = PublicKeyDto_1.PublicKeyDto.loadFromBinary(Uint8Array.from(byteArray));
        byteArray.splice(0, vrfPublicKey.getSize());
      }

      var votingPublicKeys = GeneratorUtils_1.GeneratorUtils.loadFromBinary(PinnedVotingKeyBuilder_1.PinnedVotingKeyBuilder.loadFromBinary, Uint8Array.from(byteArray), votingPublicKeysCount);
      byteArray.splice(0, votingPublicKeys.reduce(function (sum, c) {
        return sum + c.getSize();
      }, 0));
      var importanceSnapshots = undefined;

      if (format === AccountStateFormatDto_1.AccountStateFormatDto.HIGH_VALUE) {
        importanceSnapshots = ImportanceSnapshotBuilder_1.ImportanceSnapshotBuilder.loadFromBinary(Uint8Array.from(byteArray));
        byteArray.splice(0, importanceSnapshots.getSize());
      }

      var activityBuckets = undefined;

      if (format === AccountStateFormatDto_1.AccountStateFormatDto.HIGH_VALUE) {
        activityBuckets = HeightActivityBucketsBuilder_1.HeightActivityBucketsBuilder.loadFromBinary(Uint8Array.from(byteArray));
        byteArray.splice(0, activityBuckets.getSize());
      }

      var balancesCount = GeneratorUtils_1.GeneratorUtils.bufferToUint16(Uint8Array.from(byteArray));
      byteArray.splice(0, 2);
      var balances = GeneratorUtils_1.GeneratorUtils.loadFromBinary(MosaicBuilder_1.MosaicBuilder.loadFromBinary, Uint8Array.from(byteArray), balancesCount);
      byteArray.splice(0, balances.reduce(function (sum, c) {
        return sum + c.getSize();
      }, 0));
      return new AccountStateBuilder(superObject.version, address, addressHeight, publicKey, publicKeyHeight, accountType, format, supplementalPublicKeysMask, linkedPublicKey, nodePublicKey, vrfPublicKey, votingPublicKeys, importanceSnapshots, activityBuckets, balances);
    }
  }, {
    key: "createAccountStateBuilderREGULAR",
    value: function createAccountStateBuilderREGULAR(version, address, addressHeight, publicKey, publicKeyHeight, accountType, supplementalPublicKeysMask, linkedPublicKey, nodePublicKey, vrfPublicKey, votingPublicKeys, balances) {
      var format = AccountStateFormatDto_1.AccountStateFormatDto.REGULAR;
      return new AccountStateBuilder(version, address, addressHeight, publicKey, publicKeyHeight, accountType, format, supplementalPublicKeysMask, linkedPublicKey, nodePublicKey, vrfPublicKey, votingPublicKeys, undefined, undefined, balances);
    }
  }, {
    key: "createAccountStateBuilderHIGH_VALUE",
    value: function createAccountStateBuilderHIGH_VALUE(version, address, addressHeight, publicKey, publicKeyHeight, accountType, supplementalPublicKeysMask, linkedPublicKey, nodePublicKey, vrfPublicKey, votingPublicKeys, importanceSnapshots, activityBuckets, balances) {
      var format = AccountStateFormatDto_1.AccountStateFormatDto.HIGH_VALUE;
      return new AccountStateBuilder(version, address, addressHeight, publicKey, publicKeyHeight, accountType, format, supplementalPublicKeysMask, linkedPublicKey, nodePublicKey, vrfPublicKey, votingPublicKeys, importanceSnapshots, activityBuckets, balances);
    }
  }]);

  return AccountStateBuilder;
}(StateHeaderBuilder_1.StateHeaderBuilder);

exports.AccountStateBuilder = AccountStateBuilder;